/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { orderApprovalDetailsActionButtonsStyles } from "@insite/content-library/Widgets/OrderApprovalDetails/OrderApprovalDetailsActionButtons";
import { css } from "styled-components";

orderApprovalDetailsActionButtonsStyles.buttonsHiddenContainer = {
    below: "lg",
    css: css`
        display: flex;
        flex-wrap: wrap;
        gap: 5px;
    `,
};

orderApprovalDetailsActionButtonsStyles.showActivityLogButton = {
    variant: "secondary",
    css: css`
        margin-left: 0;
    `,
};

orderApprovalDetailsActionButtonsStyles.deleteButton = {
    variant: "secondary",
};

orderApprovalDetailsActionButtonsStyles.requestRevisionButton = {
    variant: "secondary",
    css: css`
        margin-left: 0;
    `,
};

orderApprovalDetailsActionButtonsStyles.approveButton = {
    variant: "primary",
};

orderApprovalDetailsActionButtonsStyles.printButton = {
    variant: "secondary",
};
